import { Form } from "antd";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

type CheckInFieldContentProps = {
  className?: string;
  getValueProps?: (value: any) => { value: any };
  children: ReactNode;
};

const CheckInFieldContent: FC<CheckInFieldContentProps> = ({ className, getValueProps, children }) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="checkin"
      className={className}
      getValueProps={getValueProps}
      rules={[{ required: true, message: t("Hotels.search.checkinRequired") }]}
    >
      {children}
    </Form.Item>
  );
};

export default CheckInFieldContent;
